// extracted by mini-css-extract-plugin
export var scrollArea = "_oj-0";